import ReactDOM from 'react-dom';
import { AppContextProvider } from '../../../Services/AppContext';
import { loadDOMComponent } from '../../../helpers';
import VideoLibrary from './VideoLibrary';

loadDOMComponent({
	selector: 'react-video-library',
	callback: ({ container, context, props }) => {
		ReactDOM.render(
			<AppContextProvider {...context}>
				<VideoLibrary {...props} />
			</AppContextProvider>,
			container,
		);
	},
});
